<div class="ticket-filter">
    <label class="active">
        <input type="radio" name="ticketFilterButton"
        value="all_tickets"
        [(ngModel)]="selectedRadioButtonValue"
        (change)="onRadioButtonSelectionChange()"
        >All <span>{{all_tickets}}</span> </label>

    <label><img class="status-icon" src="assets/images/status-neutral.svg" alt="" style="max-width: 12px;">&nbsp;<input type="radio" name="ticketFilterButton"
        value="unassigned_ticket"
        [(ngModel)]="selectedRadioButtonValue"
        (change)="onRadioButtonSelectionChange()">New  <span>{{unassigned_ticket}}</span></label>
    <label><img class="status-icon" src="assets/images/status-ok.svg" alt="" style="max-width: 12px;">&nbsp;<input type="radio"
        name="ticketFilterButton"
        value="unsolved_ticket"
        [(ngModel)]="selectedRadioButtonValue"
        (change)="onRadioButtonSelectionChange()"
        >Active <span>{{unsolved_ticket}}</span>
    </label>
    <label><img class="status-icon" src="assets/images/status-open.svg" alt="" style="max-width: 12px;">&nbsp;<input type="radio"
        name="ticketFilterButton"
        value="solved_ticket"
        [(ngModel)]="selectedRadioButtonValue"
        (change)="onRadioButtonSelectionChange()"
        >Closed <span>{{solved_ticket}}</span>
    </label>    
    <!-- <label [hidden]="curr_user_id.UserType != 1"><i class="fa fa-trash" aria-hidden="true"></i>&nbsp;
      <input type="radio"
             name="ticketFilterButton"
             value="deleted_ticket"
             [(ngModel)]="selectedRadioButtonValue"
             (change)="onRadioButtonSelectionChange()"
      >Deleted Tickets<span>{{deleted_ticket}}</span>
    </label> -->
</div>
